export default "__VITE_ASSET__BoX2UITp__"